import { render, staticRenderFns } from "./organize.vue?vue&type=template&id=260ebb62&"
import script from "./organize.vue?vue&type=script&lang=js&"
export * from "./organize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports